import React from "react";
import { SolutionSection } from "@/components/design-system/SolutionSection/SolutionSection";

const leftItems = [
  "Generic AI doesn't know your members",
  "Static portals give the same info to everyone",
  "Members who won't call or visit get nothing",
  "No guardrails, no compliance, no accountability",
] as const;

const rightItems = [
  "Grounded in each member's real accounts and balances",
  "Guidance personalized to their actual financial situation",
  "Available 24/7 — judgment-free and private",
  "Compliant by design, with your brand built in",
] as const;

export const CreditUnionSolutionSection: React.FC = () => (
  <SolutionSection
    backgroundSrc="/bg-cu-solutions.jpg"
    label="The Bravo Solution"
    heading={
      <>
        With Bravo, every member interaction is{" "}
        <span className="text-primary-500">
          a relationship opportunity.
        </span>
      </>
    }
    description="Bravo replaces passive content portals with a personalized, always-on AI financial guide — embedded in your brand, powered by your members' real account data, and built to activate engagement."
    leftItems={leftItems}
    rightItems={rightItems}
  />
);
